export const phones = [
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1677241587.64975684!348x348.jpg?f=webp",
    discount: 11,
    name: "Xiaomi 13 Pro",
    price: "79,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1680028893.42691134!348x348.jpg?f=webp",
    discount: 26,
    name: "Redmi Note 12",
    price: "13,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1650980933.40744791!348x348.jpg?f=webp",
    discount: 47,
    name: "Xiaomi 12 Pro",
    price: "41,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1641485803.86155485!348x348.png?f=webp",
    discount: 40,
    name: "Xiaomi 11i 5G",
    price: "18,999",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1642499637.27736807!348x348.jpg?f=webp",
    discount: 26,
    name: "Xiaomi 11T Pro 5G",
    price: "27,999",
  },
  {
    img: "https://i03.appmifile.com/240_item_in/16/05/2023/6f31c5aca10d8b615c43b77f10b383ad!348x348.jpg?f=webp",
    discount: 11,
    name: "Redmi A2+",
    price: "7,499",
  },
  {
    img: "https://i01.appmifile.com/v1/MI_18455B3E4DA706226CF7535A58E875F0267/pms_1680028893.42691134!348x348.jpg?f=webp",
    discount: 26,
    name: "Redmi Note 12",
    price: "13,999",
  },
  {
    img: "https://i03.appmifile.com/334_item_in/03/06/2023/52c652fe50e7d5aa9ab464b2cdd50c5b!348x348.jpg?f=webp",
    discount: 27,
    name: "Redmi A2",
    price: "6,499",
  },
];

export const phonesCarouselData = [
  {
    img: "https://i03.appmifile.com/380_operator_in/23/08/2023/31cf0807fe0b8dc20ec10aa4569aa3da.jpg?f=webp",
    para1: "Desh Ka Smart Phone",
    name: "Redmi A2+",
    para2: "Now in 4GB RAM | 128GB Storage",
    price: "7,999"
  },
  {
    img: "https://i03.appmifile.com/554_operator_in/17/08/2023/3f31282403ec7dade8b8d657ef1e1c61.jpg?f=webp",
    para1: "Slimmest Note Ever",
    name: "Redmi Note 12",
    para2: "50 MP Triple Camera",
    price: "18,999"
  },
  {
    img: "https://i03.appmifile.com/255_operator_in/23/08/2023/67382ef83d79341059a2d2792cd79676.jpg?f=webp",
    para1: "All New 12GB RAM Variant",
    name: "Redmi Note 12 Pro 5G",
    para2: "Special Exchange Bonus of Up to ₹4,000",
    price: "23,999"
  },
  {
    img: "https://i03.appmifile.com/991_operator_in/17/08/2023/2bd298ba2f336b124e8d6e4ef557d670.jpg?f=webp",
    para1: "Just Launched",
    name: "Redmi 12",
    para2: "Biggest Display Ever*",
    price: "11,499"
  }
]